import React, { useEffect, useState, useRef } from "react";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import MasterViewController from "../../redux/actions/masterApiActions";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import ExportButton from "../../components/ag grid/ExportButton";
import usePermission from "../../utils/usePermission";
import { getUserInfoFromToken } from "../../utils/authUtils";
import TremsAndConditionForm from "./AddContractTermAndConditions";
import ContractViewController from "../../redux/actions/ContractApiAction";

const TremsAndConditionPage = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);

  const { hasPermission } = usePermission();
  const { getContractTermsAndConditions, deleteContractTermsAndConditions } = ContractViewController();
  const { terms_conditions } = useSelector((state) => state.contracts);

  useEffect(() => {
    dispatch(getContractTermsAndConditions());
  }, [dispatch]);

  useEffect(() => {
    const { userType, userId } = getUserInfoFromToken();
    setUserType(userType);
    setUserId(userId);
  }, []);

  const handleDelete = (id) => dispatch(deleteContractTermsAndConditions(id));
  const handleEdit = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left",
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80,
    },
    {
      headerName: "Contract Type",
      field: "contract_type",
      flex: 1,
    },
    {
      headerName: "Terms & Conditions",
      field: "terms_and_conditions",
      flex: 2,
      valueGetter: (params) =>
        params.data.terms_and_conditions
          .map((t) => `${t.title}: ${t.description}`)
          .join(", "),
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      minWidth: 120,
      maxWidth: 150,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          {(userType === "Admin" || hasPermission("contract_terms_conditions", "edit")) && (
            <Tooltip title="Edit">
              <IconButton size="small" onClick={() => handleEdit(params.data)}>
                <Edit fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {hasPermission("contract_terms_conditions", "delete") && (
            <Tooltip title="Delete">
              <IconButton
                size="small"
                sx={{ color: "#d32f2f" }}
                onClick={() => handleDelete(params.data.id)}
              >
                <Delete fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      {/* Header + Buttons */}
      <div
        className="d-flex flex-wrap mb-3"
        style={{ justifyContent: "space-between" }}
      >
        <div className="mt-2">
          {(userType === "Admin" || hasPermission("contract_terms_conditions", "create")) && (
            <Button
              variant="contained"
              startIcon={<AddCircleOutline />}
              onClick={() => {
                setEditData(null);
                setShowModal(true);
              }}
              sx={{
                borderRadius: "8px",
                backgroundColor: "#1976d2",
                textTransform: "none",
                paddingX: 2,
                height: "40px",
                fontSize: "0.875rem",
              }}
            >
              Add Terms
            </Button>
          )}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <ExportButton
            gridRef={gridRef}
            fileName="terms.xlsx"
            exportColumns={["contract_type", "terms_and_conditions"]}
            disabled={selectedRows.length === 0}
          />
          <PageSizeSelector
            pageSize={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          />
        </div>
      </div>

      {/* Grid */}
      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={terms_conditions}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      {/* Modal */}
      <TremsAndConditionForm
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editData}
      />
    </div>
  );
};

export default TremsAndConditionPage;
